class InnovationDB {
  db: Record<number, number>;
  counter: number;

  constructor() {
    this.counter = 0;
    this.db = [];
  }

  clearDB(): void {
    this.db = [];
  }

  addInnovation(id: number): number {
    const result = this.db[id];
    if (result === undefined) {
      this.db[id] = this.counter;
      return this.counter++;
    } else {
      return result;
    }
  }
}

export default InnovationDB;
